<template>
  <div class="bigClass">
    <div class="box2">
      <div v-for="(item, index) in imgwrap" :key="index">
        <div v-if="index == page">
          <!-- <h2>{{item.value}}</h2> -->
          <div v-html="item.value"></div>
          <div class="btn">
            <el-button v-if="index > 0" @click="topPage(index)"
              >上一页</el-button
            >
            <el-button v-if="!(index == 3)" @click="nextPage(index)"
              >下一页</el-button
            >
            <el-button
              v-if="index == 3 && !dialogShow"
              type="danger"
              @click="submit"
              >进入练习</el-button
            >
            <el-button
              v-if="index == 3 && dialogShow"
              type="danger"
              @click="normal"
              >进入练习</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible="showDialog"
      v-if="showDialog"
      @close="btnCancel"
      center
    >
      <div class="topic">系统监测到您有上次未打完题目</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goOn">继 续 答 题</el-button>
        <el-button type="primary" @click="normal">重 新 开 始</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
//
import {
  getSchedule,
  currentTimes,
  scaleAnswerNextTimes,
  getScaleAnswerData
} from '@/api/login/login';
export default {
  data() {
    return {
      imgwrap: [
        {
          value:
            '<h2>儿童认知发展测验施测说明</h2><h3>壹、此测试量表简介</h3> <p>一、适用对象：儿童认知发展测验编制的目的，旨在评量三至十二岁学前及学龄儿童对于图形的认知与图形的推理能力，并作为筛选学前及学龄儿童是否具有智力上的障碍之非语文个别智力测验工具。</p> <p>二、编制依据：本测验是研究者参考盲人学习性向测验、非语文智力测验（TON1-2）、哥伦比亚心理成熟量表、魏氏儿童智力量表、瑞文图形推理测验系列、伊利诺心理语言能力测试、《拜动物为师》一书中的插图、罗桑多层次智力测验等理论架构而自编的非语言个别智力测验。</p> <p>二、本测验共分为六个分测验：</p> <p>分测验一为图形辨别测验，包括一至二十三题；</p> <p>分测验二为补充图形测验，包括二十四题至三十题；</p> <p>分测验三为隐藏图形测验，包括三十一至四十二题；</p> <p>分测验四为图形关系测验，包括四十三题至六十七题；</p> <p>分测验五为圆形系列测验，包括六十八至八十七题；</p> <p>分测验六为图形关系系列测验，包括八十八题至九十二题。</p> <p>三、特点：本测验为儿童日常生活中熟知的彩色图画，施测简单，学生极感兴趣， 记分评分也很容易，测验时间只需30-50分钟，且无时间限制，故极适合做为筛选工具，加上不需以语言作答，只需极少的动作能力，所以又特别适用于评量有语言、运动障碍的脑性麻痹、语言障碍、智能不足、听觉障碍、弱视、自闭症及学习障碍等类儿童。</p>'
        },
        {
          value:
            '<h2>儿童认知发展测验施测说明</h2><h3>贰、测验前的准备事项</h3><p>一 、准备一安静测验场所，包括一套评测系统。</p><p>二 、准备测验材料，包括测验题本、答案纸、笔、码表或手表。</p><p>三 、和受试者建立良好的关系，必要时向受试者解释施测的目的及说明测验结果的使用范围。</p><p>四 、指导受试者完成档案的个人资料填写或由施测人员协助完成。</p><p>五 、受试者如为智能不足、听觉障碍、语言障碍、弱视、 自闭症或学习障碍儿童，为增进其对于施测方法之理解，可以将施测注意事项、练习题，以大字报挂在黑板上，以口语或手语加以说明。</p>'
        },
        {
          value:
            '<h2>儿童认知发展测验施测说明</h2><h3>参、施测方式</h3><p>本测验以个别方式实施， 一般儿童做完整个测验， 平均为30-50分钟。</p>'
        },
        {
          value:
            '<h2>儿童认知发展测验施测说明</h2><h3>肆、测验之实施</h3><p>一、安排受试者就位；</p><p>二、打开测验系统，让受试者可清楚看到题目及选项；</p><p>三、本测验共有六个练习题，分别是图形辨别、补充图形、图形关系、图形系列、图形系列关系及隐藏图形等。</p><p>四、如果在六个练习题做完之后，受试者仍旧无法清楚的作答时，则将全部的练习题再做一次。如果受试者仍旧无法做答时，就停止施测。练习题不计分，亦不做记录。</p><p> 五、如果受试顺利完成练习题，并已清楚了解作答的方式，则继续题本右下角第一页的题目开始作答。</p>'
        }
      ],
      page: '0',
      showDialog: false,
      studentIdA: sessionStorage.getItem('studentIdA'),
      dialogShow: false
    };
  },
  computed: {
    lastList() {
      return this.$store.state.lastList;
    }
  },
  mounted() {
    this.currentTimes();
  },
  methods: {
    nextPage(index) {
      console.log(index);
      index++;
      this.page++;
    },
    topPage(index) {
      index--;
      this.page--;
      console.log(index);
    },
    normal() {
      this.scaleAnswerNextTimes(this.studentIdA);
      sessionStorage.removeItem('lastList');
      sessionStorage.removeItem('last');
      this.$router.push({ name: 'home' });
    },
    submit() {
      this.showDialog = true;
    },
    btnCancel() {
      this.showDialog = false;
    },
    async currentTimes() {
      try {
        const data = await currentTimes(this.studentIdA);
        if (data.code == 0) {
          this.$store.commit('setTimes', data.data);
          this.getSchedule();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getSchedule() {
      let params = {
        studentId: this.studentIdA,
        times: this.times
      };
      try {
        const data = await getSchedule(params);
        if (data.code == 0) {
          let res = data.data;
          if (res.schedule == '已完成') {
            return (this.dialogShow = true);
          } else if (res.schedule && res.schedule !== '已完成') {
            this.getScaleAnswerData();
          }
          console.log(res);
        }
      } catch (err) {
        this.dialogShow = true;
        console.log(err);
      }
    },
    // 次数
    async scaleAnswerNextTimes(id) {
      const data = await scaleAnswerNextTimes(id);
      if (data.code == 0) {
        this.$store.commit('setTimes', data.data);
      }
    },
    async getScaleAnswerData() {
      let params = {
        studentId: this.studentIdA,
        times: this.times
      };
      const data = await getScaleAnswerData(params);
      if (data.code == 0) {
        let newList = data.data;
        console.log(newList);
        for (let i = 0; i < this.lastList.length; i++) {
          for (let j = 0; j < newList.length; j++) {
            if (this.lastList[i].name === newList[j].scaleName) {
              this.lastList[i].nums = newList[j].options;
            }
          }
        }
        let filteredList = this.lastList
          .filter((item) => item.nums !== '')
          .pop();
        console.log(filteredList);
        console.log(this.lastList);
        sessionStorage.setItem('lastList', JSON.stringify(this.lastList));
        sessionStorage.setItem('last', JSON.stringify(filteredList));
      }
    },
    //继续答题
    goOn() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>
<style lang='scss' scoped>
.bigClass {
  background-image: url('~@/assets/appraisal.png'); // 设置背景图片
  background-attachment: fixed;
  background-position: center;
  // background-size: 100% 100%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: hidden;
  // align-items: center;
}
.box2 {
  width: 800px;
  // height: 850px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 40px;
  line-height: 30px;
}
.centerText {
  text-align: center;
}

/* .el-carousel__arrow--left {
  display: none;
} */
.carValue {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn {
  height: 50px;
  text-align: center;
  position: fixed;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
}
// 对话框圆角
::v-deep .el-dialog__wrapper {
  .el-dialog {
    border-radius: 10px;
  }
}

.topic {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
</style>
